import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EAccountRole, ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { CustomValidators } from 'src/app/shared/utilities/custom-validators';
import { CentroCustosService } from '../services/centro-custos.service';
import { CompanyService } from '../../companies/services/company.service';
import { ICompany } from '../../companies/models/company.interface';
import { canPickCompany } from 'src/app/shared/utilities/company-scope';
import { interceptorAvisouErro } from 'src/app/shared/http-interceptor/http-interceptor.module';

@Component({
  selector: 'app-edit-centro-custos',
  templateUrl: './edit-centro-custos.component.html',
  styleUrls: ['./edit-centro-custos.component.scss']
})
export class EditCentroCustosComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  @Output() recarregarListagem = new EventEmitter();
  centroId?: string | null;
  opcoesListCompany: ICompany[] = [];
  podeEscolherEmpresa = false;
  formEditCentro = new UntypedFormGroup({
    id: new UntypedFormControl(null),
    description: new UntypedFormControl('', [CustomValidators.requiredTrimmed]),
    code: new UntypedFormControl(null, [CustomValidators.requiredTrimmed]),
    companyId: new UntypedFormControl(null, [Validators.required]),
    companyName: new UntypedFormControl('')
  });

  companyId?: string;
  partnerId?: string;
  accountRole?: EAccountRole;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly toastService: ToastService,
    private readonly companyService: CompanyService,
    private readonly centroservice: CentroCustosService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.centroId = this.activatedRoute.snapshot.paramMap.get('id');
    this.companyId = this.sessionService.getSession().companyId;
    this.partnerId = this.sessionService.getSession().partnerId;
    this.accountRole = parseInt(this.sessionService.getSession().accountRole);

    if (this.centroId) {
      this.carregarDetalhesCentro(this.centroId);
    }

    if (this.accountRole === EAccountRole.Doctor) {
      //TODO: trazer companies que o doctor participa.
      this.formEditCentro.get('companyId')?.disable();
    } else {
      if (this.companyId) {
        this.formEditCentro.get('companyId')?.patchValue(this.companyId);
        this.formEditCentro.get('companyId')?.disable();
      }
    }

    // Usuário de empresa fica fixo na dele (mesmo com parceiro no token); interno e parceiro sem empresa trocam.
    this.podeEscolherEmpresa = canPickCompany(this.sessionService.getSession());
    if (this.podeEscolherEmpresa) {
      this.getListEmpresas();
    }
  }

  public carregarDetalhesCentro(centroId: string): void {
    this.formEditCentro.get('id')!.patchValue(centroId);

    this.centroservice.detalhesCentrosCusto(centroId).subscribe((res) => {
      if (res.messages && res.messages.length > 0) {
        this.toastService.toast(res.messages);
      }
      if (res.isSucceed) {
        this.formEditCentro.get('description')!.patchValue(res.data.description);
        this.formEditCentro.get('code')!.patchValue(res.data.code);
        this.formEditCentro.get('companyId')!.patchValue(res.data.companyId);
        // this.formEditCentro.get('companyName')?.patchValue(res.data.company?.name);
      }
    });
  }

  fechar(): void {
    this.router.navigateByUrl('/dash/centro-custos');
  }

  editCentro(): void {
    if (this.formEditCentro.invalid) {
      this.toastService.toast('Preencha todos os campos obrigatórios antes de salvar.', EMessageType.Error);
      this.formEditCentro.markAllAsTouched();
      return;
    }

    const dadosFormulario = this.formEditCentro.getRawValue();
    const empresaVinculada = this.opcoesListCompany.find((company) => company.id === dadosFormulario.companyId);
    this.formEditCentro.get('companyName')?.patchValue(empresaVinculada?.name);

    this.centroservice.editarCentrosCusto(this.formEditCentro.getRawValue()).subscribe({
      next: (res) => {
        if (res.messages && res.messages.length > 0) {
          this.toastService.toast(res.messages);
        }

        if (res.isSucceed) {
          this.router.navigateByUrl('/dash/centro-custos');
          this.recarregarListagem.emit();
        }
      },
      error: () => this.toastService.toast('Erro ao salvar o centro de custo. Tente novamente.', EMessageType.Error)
    });
  }

  getListEmpresas(): void {
    // O backend escopa pelo token: interno vê todas, parceiro só as dele.
    this.companyService.listarEmpresasAtivas().subscribe({
      next: (resposta) => {
        this.opcoesListCompany = resposta.data;
      },
      error: (erro) => {
        this.opcoesListCompany = [];
        if (!interceptorAvisouErro(erro)) {
          this.toastService.toast('Erro ao carregar as empresas. Tente novamente.', EMessageType.Error);
        }
      }
    });
  }
}
